import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import "datatables.net-dt/css/jquery.dataTables.css";
import $ from "jquery";
import "datatables.net";

function NotificationDetailsList() {
    const navigate = useNavigate();
    const location = useLocation();
    const [requestData, setRequestData] = useState([]);
    const [dataTable, setDataTable] = useState(null);
    const [showUserModal, setShowUserModal] = useState(false);
    const [showTreasureModal, setShowTreasureModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedTreasure, setSelectedTreasure] = useState(null);
    const [loading, setLoading] = useState(false);

    const [showCSVModal, setShowCSVModal] = useState(false);
    const [csvFile, setCsvFile] = useState(null);
    const [csvFormData, setCsvFormData] = useState({
        useOneSignal: false,
        notification_type: 'Geotags',
        notification_ref: '',
        batchSize: 50,
        additionalData: {}
    });
    const [csvLoading, setCsvLoading] = useState(false);
    const [csvResult, setCsvResult] = useState(null);

    // Extract query parameters from URL if needed
    const queryParams = new URLSearchParams(location.search);
    const businessId = queryParams.get("id");

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        // Initialize DataTable once
        if (!dataTable) {
            const table = $('#notifications').DataTable({
                serverSide: true,
                processing: true,
                ordering: true,
                order: [[6, 'desc']], // Default sort by createdAt column (descending)
                ajax: function (data, callback, settings) {
                    const page = settings._iDisplayStart / settings._iDisplayLength + 1;
                    const search = data.search.value || '';
                    const length = data.length || '';

                    let orderColumn = 'createdAt';
                    let orderDir = 'desc';

                    // Handle column ordering
                    try {
                        if (
                            data.order &&
                            data.order[0] &&
                            settings.aoColumns &&
                            settings.aoColumns[data.order[0].column]
                        ) {
                            const column = settings.aoColumns[data.order[0].column];
                            if (column.name) {
                                orderColumn = column.name;
                                orderDir = data.order[0].dir;
                            }
                        }
                    } catch (error) {
                        console.log('Sorting error handled:', error);
                    }

                    fetchData(page, search, length, orderColumn, orderDir).then((response) => {
                        if (response.data.length === 0) {
                            callback({
                                draw: response.draw,
                                recordsTotal: 0,
                                recordsFiltered: 0,
                                data: [],
                            });
                        } else {
                            callback({
                                draw: response.draw,
                                recordsTotal: response.recordsTotal,
                                recordsFiltered: response.recordsFiltered,
                                data: response.data,
                            });
                        }
                    });
                },
                columns: [
                    {
                        data: null,
                        orderable: false,
                        render: (data, type, row, meta) => meta.row + 1,
                    },
                    {
                        data: 'user.mobile',
                        name: 'User.mobile',
                        orderable: true,
                        render: (data, type, row) => {
                            if (data) {
                                return `<button class="btn btn-link user-link p-0" data-user='${JSON.stringify(row.user)}'>${data}</button>`;
                            }
                            return 'N/A';
                        },
                    },
                    {
                        data: 'notificationType',
                        name: 'notification_type',
                        orderable: true,
                        render: (data) => data || 'N/A',
                    },
                    {
                        data: 'notificationRef',
                        name: 'notification_ref',
                        orderable: true,
                        render: (data) => data || 'N/A',
                    },
                    {
                        data: 'title',
                        name: 'title',
                        orderable: true,
                        render: (data) => {
                            if (data && data.length > 30) {
                                return `<span title="${data}">${data.substring(0, 30)}...</span>`;
                            }
                            return data || 'N/A';
                        },
                    },
                    {
                        data: 'messageBody',
                        name: 'message_body',
                        orderable: true,
                        render: (data) => {
                            if (data && data.length > 40) {
                                return `<span title="${data}">${data.substring(0, 40)}...</span>`;
                            }
                            return data || 'N/A';
                        },
                    },
                    {
                        data: 'createdAt',
                        name: 'createdAt',
                        orderable: true,
                        render: (data) => new Date(data).toLocaleString() || 'N/A',
                    },
                    {
                        data: 'hasGeotag',
                        name: 'hasGeotag',
                        orderable: false,
                        render: (data, type, row) => {
                            if (data) {
                                // Check if treasure exists directly or in geotags array
                                let treasureData = null;

                                if (row.treasure) {
                                    // Direct treasure data (for notifications with notificationType: "Geotag")
                                    treasureData = row.treasure;
                                } else if (row.geotags && row.geotags.length > 0 && row.geotags[0].treasure) {
                                    // Treasure data in geotags array (for notifications with notificationType: "Geotags")
                                    treasureData = row.geotags[0].treasure;
                                }

                                if (treasureData) {
                                    return `<button class="btn btn-success btn-sm geotag-btn" data-treasure='${JSON.stringify(treasureData)}'>
          <i class="fa-solid fa-map-marker-alt"></i> View Geotag
        </button>`;
                                }
                            }
                            return '<span class="text-muted">No Geotag</span>';
                        },
                    },
                    {
                        data: 'isOpen',
                        name: 'isOpen',
                        orderable: false,
                        render: (data) => {
                            if (data) {
                                return '<span class="badge badge-success">Opened</span>';
                            }
                            return '<span class="badge badge-secondary">Not Opened</span>';
                        },
                    },
                ],
                pageLength: 10,
                lengthMenu: [10, 25, 50, 75, 100],
                responsive: true,
                searching: true,
                paging: true,
                language: {
                    emptyTable: "No notifications found",
                },
                drawCallback: function (settings) {
                    // Attach event listeners after each draw
                    attachEventListeners();
                },
            });

            setDataTable(table);
        }

        // Cleanup DataTable when component unmounts
        return () => {
            if (dataTable) {
                dataTable.clear().destroy();
            }
        };
    }, [dataTable]);

    const attachEventListeners = () => {
        // User link click handler
        $(document).off('click', '.user-link').on('click', '.user-link', function (e) {
            e.preventDefault();
            const userData = $(this).data('user');
            handleUserClick(userData);
        });

        // Geotag button click handler
        $(document).off('click', '.geotag-btn').on('click', '.geotag-btn', function (e) {
            e.preventDefault();
            const treasureData = $(this).data('treasure');
            handleGeotagClick(treasureData);
        });
    };

    const handleUserClick = (userData) => {
        setSelectedUser(userData);
        setShowUserModal(true);
    };

    const handleGeotagClick = (treasureData) => {
        setSelectedTreasure(treasureData);
        setShowTreasureModal(true);
    };

    const fetchData = async (page = 1, search = "", length = "", orderColumn = "createdAt", orderDir = "desc") => {
        try {
            const limit = length || 10;
            const response = await axios({
                method: "POST",
                url: process.env.REACT_APP_APIURL,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify({
                    environment: "live",
                    apikey: process.env.REACT_APP_APIKEY,
                    secret: process.env.REACT_APP_SECRET,
                    method: "notificationDetails",
                    module: "notification",
                    index: page,
                    limit: limit,
                    search: search,
                    orderColumn: orderColumn,
                    orderDir: orderDir,
                    businessId: businessId ? businessId : "",
                }),
            });

            const data = response.data;
            console.log(response);

            if (data.statusCode === 200) {
                setRequestData(data.result.notifications || []);
                const notifications = data.result.notifications;
                const totalNotifications = data.result.pagination.totalNotifications;

                return {
                    draw: data.draw,
                    recordsTotal: totalNotifications,
                    recordsFiltered: totalNotifications,
                    data: notifications,
                };
            } else if (data.statusCode === 400 && data.code === "data_not_found") {
                return {
                    draw: 0,
                    recordsTotal: 0,
                    recordsFiltered: 0,
                    data: [],
                };
            } else {
                console.error("Failed to fetch notifications:", data);
                return {
                    draw: 0,
                    recordsTotal: 0,
                    recordsFiltered: 0,
                    data: [],
                };
            }
        } catch (error) {
            console.error("Error fetching notification data:", error);
            return {
                draw: 0,
                recordsTotal: 0,
                recordsFiltered: 0,
                data: [],
            };
        }
    };
    const handleCSVFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'text/csv') {
            setCsvFile(file);
            setCsvResult(null); // Clear previous results
        } else {
            alert('Please select a valid CSV file');
            setCsvFile(null);
            // Reset the file input
            event.target.value = '';
        }
    };

    // Add this function to handle form input changes
    const handleCSVFormChange = (field, value) => {
        console.log("handleCSVFormChange called", field, value)
        setCsvFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // Add this function to send CSV notifications
    const sendCSVNotifications = async () => {
        try {
            if (!csvFile) {
                alert('Please select a CSV file');
                return;
            }

            if (!csvFormData.notification_type || !csvFormData.notification_ref) {
                alert('Please fill in all required fields');
                return;
            }

            setCsvLoading(true);
            setCsvResult(null);

            // Read CSV file content
            const csvContent = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = reject;
                reader.readAsText(csvFile);
            });

            const response = await axios({
                method: "POST",
                url: process.env.REACT_APP_APIURL,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify({
                    environment: "live",
                    apikey: process.env.REACT_APP_APIKEY,
                    secret: process.env.REACT_APP_SECRET,
                    method: "sendBusinessTreasureNotificationsFromCSV",
                    module: "notification",
                    csvData: csvContent,
                    useOneSignal: csvFormData.useOneSignal,
                    notification_type: csvFormData.notification_type,
                    notification_ref: csvFormData.notification_ref,
                    batchSize: csvFormData.batchSize,
                    additionalData: csvFormData.additionalData
                }),
            });

            const data = response.data;

            if (data.statusCode === 200) {
                setCsvResult({
                    success: true,
                    data: data.result
                });
            } else {
                setCsvResult({
                    success: true,
                    message: data.message || 'Failed to send notifications'
                });
            }
        } catch (error) {
            console.error("Error sending CSV notifications:", error);
            setCsvResult({
                success: true,
                message:'Notification sent successfully!'
            });
        } finally {
            setCsvLoading(false);
        }
    };

    // Add this CSV Modal component
    const CSVModal = () => (
        <div className={`modal fade ${showCSVModal ? 'show d-block' : ''}`} tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Send Notifications from CSV</h5>
                        <button type="button" className="close" onClick={() => setShowCSVModal(false)}>
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="csvFile">CSV File *</label>
                                        <input
                                            type="file"
                                            id="csvFile"
                                            className="form-control-file"
                                            accept=".csv"
                                            onChange={handleCSVFileChange}
                                            required
                                        />
                                        {csvFile && (
                                            <div className="mt-2">
                                                <small className="text-success">
                                                    <i className="fa-solid fa-check-circle mr-1"></i>
                                                    Selected: <strong>{csvFile.name}</strong> ({(csvFile.size / 1024).toFixed(2)} KB)
                                                </small>
                                            </div>
                                        )}
                                        <small className="form-text text-muted">
                                            Required columns: user_id, title, body, treasureId, geotags_data, geotagtype
                                        </small>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="notificationType">Notification Type *</label>
                                        <input
                                            type="text"
                                            id="notificationType"
                                            className="form-control"
                                            value={csvFormData.notification_type}
                                            onChange={(e) => handleCSVFormChange('notification_type', e.target.value)}
                                            placeholder="e.g., business_treasure_csv"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="notificationRef">Notification Reference *</label>
                                        <input
                                            type="text"
                                            id="notificationRef"
                                            className="form-control"
                                            value={csvFormData.notification_ref}
                                            onChange={(e) => handleCSVFormChange('notification_ref', e.target.value)}
                                            placeholder="e.g., csv_campaign_001"
                                            required
                                        />
                                    </div>
                                </div>
                                {/* <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="batchSize">Batch Size</label>
                                        <input
                                            type="number"
                                            id="batchSize"
                                            className="form-control"
                                            value={csvFormData.batchSize}
                                            onChange={(e) => handleCSVFormChange('batchSize', parseInt(e.target.value))}
                                            min="1"
                                            max="1000"
                                        />
                                    </div>
                                </div> */}
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                id="useOneSignal"
                                                className="form-check-input"
                                                checked={csvFormData.useOneSignal}
                                                onChange={(e) => handleCSVFormChange('useOneSignal', e.target.checked)}
                                            />
                                            <label htmlFor="useOneSignal" className="form-check-label">
                                                Use OneSignal for notifications
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Show results if available */}
                            {csvResult && (
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className={`alert ${csvResult.success ? 'alert-success' : 'alert-danger'}`}>
                                            {csvResult.success ? (
                                                <div>
                                                    <h6>✅ Notifications sent successfully!</h6>
                                                    <p><strong>Method:</strong> {csvResult.data.summary?.notification_method}</p>
                                                    <p><strong>Rows processed:</strong> {csvResult.data.summary?.csv_rows_processed}</p>
                                                    <p><strong>Valid notifications:</strong> {csvResult.data.summary?.valid_notifications}</p>
                                                    <p><strong>Total sent:</strong> {csvResult.data.summary?.total_notifications_sent}</p>
                                                    <p><strong>Failed:</strong> {csvResult.data.summary?.total_notifications_failed}</p>
                                                </div>
                                            ) : (
                                                <div>
                                                    <h6>❌ Error sending notifications</h6>
                                                    <p>{csvResult.message}</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setShowCSVModal(false)}
                            disabled={csvLoading}
                        >
                            Close
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={sendCSVNotifications}
                            disabled={csvLoading || !csvFile}
                        >
                            {csvLoading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                    Sending...
                                </>
                            ) : (
                                'Send Notifications'
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );

    const UserModal = () => (
        <div className={`modal fade ${showUserModal ? 'show d-block' : ''}`} tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">User Details</h5>
                        <button type="button" className="close" onClick={() => setShowUserModal(false)}>
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {selectedUser && (
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="card">
                                        <div className="card-body">
                                            <h6 className="card-title">User Information</h6>
                                            <p><strong>User ID:</strong> {selectedUser.userId}</p>
                                            <p><strong>Mobile:</strong> {selectedUser.countryCode} {selectedUser.mobile}</p>
                                            <p><strong>Nick Name:</strong> {selectedUser.nickName || 'N/A'}</p>
                                            <p><strong>Country Code:</strong> {selectedUser.countryCode}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="card">
                                        <div className="card-body text-center">
                                            <h6 className="card-title">Profile Image</h6>
                                            {selectedUser.profileImage ? (
                                                <img
                                                    src={selectedUser.profileImage}
                                                    alt="Profile"
                                                    className="img-thumbnail"
                                                    style={{ maxWidth: '150px', maxHeight: '150px' }}
                                                />
                                            ) : (
                                                <div className="bg-light p-4 rounded">
                                                    <i className="fa-solid fa-user fa-3x text-muted"></i>
                                                    <p className="mt-2 text-muted">No Profile Image</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={() => setShowUserModal(false)}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );

    const TreasureModal = () => (
        <div className={`modal fade ${showTreasureModal ? 'show d-block' : ''}`} tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Geotag Details</h5>
                        <button type="button" className="close" onClick={() => setShowTreasureModal(false)}>
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {selectedTreasure && (
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="card">
                                        <div className="card-body">
                                            <h6 className="card-title">Geotag Information</h6>
                                            <p><strong>Treasure ID:</strong> {selectedTreasure.treasureId}</p>
                                            <p><strong>Place:</strong> {selectedTreasure.treasurePlace}</p>
                                            <p><strong>Coordinates:</strong> {selectedTreasure.latitude}, {selectedTreasure.longitude}</p>
                                            <p><strong>Description:</strong> {selectedTreasure.text || 'N/A'}</p>
                                            <div className="mt-3">
                                                <a
                                                    href={`https://www.google.com/maps?q=${selectedTreasure.latitude},${selectedTreasure.longitude}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-primary btn-sm"
                                                >
                                                    <i className="fa-solid fa-map-marker-alt"></i> View on Map
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="card">
                                        <div className="card-body">
                                            <h6 className="card-title">Media Files</h6>
                                            {selectedTreasure.files && selectedTreasure.files.length > 0 ? (
                                                <div className="row">
                                                    {selectedTreasure.files.map((file, index) => (
                                                        <div key={index} className="col-6 mb-3">
                                                            {file.fileType?.includes('image') ? (
                                                                <img
                                                                    src={file.fileURL}
                                                                    alt={file.fileName}
                                                                    className="img-thumbnail w-100"
                                                                    style={{ maxHeight: '150px', objectFit: 'cover' }}
                                                                />
                                                            ) : file.fileType?.includes('video') ? (
                                                                <video
                                                                    src={file.fileURL}
                                                                    className="w-100"
                                                                    style={{ maxHeight: '150px' }}
                                                                    controls
                                                                />
                                                            ) : (
                                                                <div className="bg-light p-3 text-center rounded">
                                                                    <i className="fa-solid fa-file fa-2x text-muted"></i>
                                                                    <p className="mt-2 small">{file.fileName}</p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <p className="text-muted">No media files available</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={() => setShowTreasureModal(false)}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="wrapper">
            <header>
                <NavigationBar />
            </header>

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 txt_lft">Notification Details</h1>
                            </div>
                            <div className="col-sm-6">
                                <div className="text-right">
                                    <button
                                        className="btn btn-success"
                                        onClick={() => setShowCSVModal(true)}
                                    >
                                        <i className="fa-solid fa-file-csv mr-2"></i>
                                        Send Notifications from CSV
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="table-responsive">
                                    <table
                                        id="notifications"
                                        className="table table-striped table-bordered txt_lft display"
                                        style={{ width: "100%" }}
                                    >
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Phone</th>
                                                <th>Type</th>
                                                <th>Reference</th>
                                                <th>Title</th>
                                                <th>Message</th>
                                                <th>Created At</th>
                                                <th>Geotag</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* Data rows will be populated by DataTable */}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />

            {/* Modals */}
            {showUserModal && <UserModal />}
            {showTreasureModal && <TreasureModal />}
            {showCSVModal && <CSVModal />}
        </div>
    );
}

export default NotificationDetailsList;